export const TaskOption = [
    { label: 'All', value: 0 },
    { label: 'Create', value: 1 },
    { label: 'Update', value: 2 },
    { label: 'Delete', value: 3 },
    { label: 'Add', value: 4 },
    { label: 'Remove', value: 5 }
];
